var map = {
	"./afiliacion.png": 7584,
	"./certificado.png": 6959,
	"./cheque.png": 7071,
	"./confiar.png": 368,
	"./contactanos.png": 3410,
	"./contratacion.png": 875,
	"./depura.png": 5037,
	"./desktop.ini": 1944,
	"./impuesto.png": 1124,
	"./logo.svg": 5111,
	"./logodys.png": 1170,
	"./nomina.png": 8028,
	"./oil.png": 5310,
	"./pruebas.png": 3168,
	"./recluta.png": 8303,
	"./seleccion.png": 8336,
	"./sgsst.png": 8222,
	"./social.png": 7221,
	"./tramites.png": 6981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3022;